"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * makeUpObj
 * @param {object} objRes object used to write the final result
 * @param {string} key path inside object whete you want to place it like: info.data
 * @param {string||number} value value to associate
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const makeUpObj = (key, value) => {
    const obj = {};
    const parts = key.split(".");
    if (parts.length === 1) {
        obj[parts[0]] = value;
    }
    else if (parts.length > 1) {
        // concat all but the first part of the key
        const remainingParts = parts.slice(1, parts.length).join(".");
        obj[parts[0]] = makeUpObj(remainingParts, value);
    }
    return obj;
};
exports.default = makeUpObj;
//# sourceMappingURL=index.js.map